import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { smartDateString } from '../../utils/date';

const html = '';
function fillElement(elementById: HTMLElement, responseInfo: any, key: string) {
  const func = elementById.getAttribute('data-func');
  const visible = elementById.getAttribute('data-visible');

  let value = responseInfo[key];
  if (typeof value === 'object') value = value.value;
  if (func) {
    if (func === 'date') {
      const format = elementById.getAttribute('data-format');
      value = smartDateString(
        Number(value),
        false,
        true,
        true,
        format || undefined
      );
    }
  }
  if (visible) {
    if (value.toString() !== visible) {
      elementById.style.display = 'none';
    }
  } else if (elementById.tagName === 'IMG') {
    (elementById as HTMLImageElement).src = value;
  } else elementById.innerText = value;
}

export const PrintSurveyResponse: React.FC<RouteComponentProps> = () => {
  const responseString = localStorage.getItem('printableSurveyResponse');
  const responseInfo = JSON.parse(responseString || '{}');
  // localStorage.removeItem('printableSurveyResponse');

  setTimeout(() => {
    Object.keys(responseInfo).forEach((key) => {
      const elementById = document.getElementById(key);
      if (elementById) {
        fillElement(elementById, responseInfo, key);
      }
      const elementsByName = document.getElementsByName(key);
      elementsByName.forEach((e) => {
        fillElement(e, responseInfo, key);
      });
    });
  }, 200);
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html || responseInfo.printTemplate }}
    />
  );
};
